import { createFileRoute } from '@tanstack/react-router'
import { DocumentViewerPage } from '@/features/document-viewer/ui/DocumentViewerPage'
import { parseRouteId } from '@/features/document-viewer/lib/parseRouteId'

export const Route = createFileRoute('/documents/payslip/$accountId/$runId')({
  component: PayslipDocumentRoute,
  staticData: { authorize: false },
})

function PayslipDocumentRoute() {
  const { accountId, runId } = Route.useParams()
  return <DocumentViewerPage kind="payslip" accountId={parseRouteId(accountId)} documentId={parseRouteId(runId)} />
}
